import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toJS } from '../../../utils/immutableUtils';
import {
  getGlobalApprovalPpsi,
  getFetchError,
  getIsFetching
} from '../selectors';
import { fetchGlobalApprovalPpsi } from '../actions';

const useReviewPpsi = (id, { forceFetch = false } = {}) => {
  const dispatch = useDispatch();
  const [isMounted, setIsMounted] = useState(false);
  const ppsi = useSelector(getGlobalApprovalPpsi);
  const isFetchingPpsi = useSelector(getIsFetching);
  const fetchError = useSelector(getFetchError);
  const isFetching = !isMounted ? true : isFetchingPpsi;
  const isFetched = !!ppsi;

  const localMarket = JSON.parse(localStorage.getItem('localMarket'));
  // const marketLanguage = JSON.parse(localStorage.getItem('marketLanguage'));

  useEffect(() => {
    if (isMounted) {
      return;
    }
    if (!isFetched || forceFetch) {
      dispatch(fetchGlobalApprovalPpsi(localMarket, id));
    }
    setIsMounted(true);
  }, [id, dispatch, forceFetch, isFetched, isMounted]);

  return [isFetching, isFetching ? null : toJS(ppsi), fetchError];
};

export default useReviewPpsi;
